/**
 * Transforma una URL de Cloudinary para servir imágenes optimizadas.
 * Cloudinary permite pasar parámetros de transformación en la URL.
 *
 * Ejemplo original:
 * https://res.cloudinary.com/cloud_name/image/upload/v123/readings/user_id/filename.jpg
 *
 * Con transformación:
 * https://res.cloudinary.com/cloud_name/image/upload/w_120,h_120,c_fill,f_auto,q_auto/v123/...
 */
export function cloudinaryThumb(url, width = 120, height = 120) {
  if (!url || !url.includes('cloudinary.com')) return url;
  return url.replace(
    '/upload/',
    `/upload/w_${width},h_${height},c_fill,f_auto,q_auto:low/`
  );
}

export function cloudinaryPreview(url, width = 800) {
  if (!url || !url.includes('cloudinary.com')) return url;
  return url.replace(
    '/upload/',
    `/upload/w_${width},f_auto,q_auto/`
  );
}
